import React from 'react';
import PropTypes from 'prop-types';
import BasicRadio from "../BasicFormFields/Radio";
import {includes, SupportedLangs} from "../../../utils/DBUtils";
import {connect} from 'react-redux';
import {getUserLangs} from "../../../pages/Profile/selectors";

const langOptionConfigs = {
    'en-US': {key: 'en-US', text: 'Dailybreak', value: 'en-US'},
    'es-LA': {key: 'es-LA', text: 'El Dailybreak', value: 'es-LA'},
    'en-GB': {key: 'en-GB', text: 'Dailybreak UK', value: 'en-GB'}
};

const LangRadioOptions = (props) => {
    const options = SupportedLangs.map((lang) => {
        const allowed = includes(props.allowedLangs, lang);
        const config = langOptionConfigs[lang];
        return {
            ...config,
            disabled: !allowed
        }
    });
    return (
        <BasicRadio value={props.value}
                    label={props.label}
                    name='lang-radio'
                    options={options}
                    onValueChanged={props.onValueChanged}/>
    )
};

LangRadioOptions.propTypes = {
    value: PropTypes.any,
    allowedLangs: PropTypes.arrayOf(PropTypes.string),
    label: PropTypes.node
};

LangRadioOptions.defaultProps = {
    allowedLangs: []
};

const mapStateToProps = (state) => {
    const langs = getUserLangs(state);
    return {
        allowedLangs: langs
    }
};

const ConnectedLangRadioOptions = connect(mapStateToProps, null)(LangRadioOptions);

export default ConnectedLangRadioOptions;



// WEBPACK FOOTER //
// ./public/components/forms/CustomFields/LangRadioOptions.jsx